import type { IConfigPortalCredentialRepository } from "@src/domain/repositories/config";
import type { GetConfigPortalCredentialsDTO } from "@src/domain/dto/config";

export class GetConfigPortalCredentialsUseCase {
  private readonly repository: IConfigPortalCredentialRepository;

  constructor(repository: IConfigPortalCredentialRepository) {
    this.repository = repository;
  }

  execute(params: GetConfigPortalCredentialsDTO) {
    return this.repository.getPortalCredentials(params);
  }
}
